/**
 * 数组转为对象
 * @param array 数组
 * @param keyProp 对象的键属性名
 * @param valueProp 对象的值属性名
 *
 * @example
 * const array = [
 *   { id: '0', name: 'foo' },
 *   { id: '1', name: 'bar' },
 * ]
 *
 * array2Object(array, 'id')
 * // { '0': { id: '0', name: 'foo' }, '1': { id: '1', name: 'bar' } }
 *
 * array2Object(array, 'id', 'name')
 * // { '0': 'foo', '1': 'bar' }
 */

function array2Object(array, keyProp, valueProp) {
  var record = {};
  array.forEach(function (item) {
    record[item[keyProp]] = valueProp ? item[valueProp] : item;
  });
  return record;
}

/**
 * 断言
 * @param condition 断言条件
 * @param message 错误信息
 * @param constructor 错误对象构造函数
 */

function assert(condition, arg1, arg2) {
  if (!condition) {
    var Constructor = typeof arg1 === 'function' ? arg1 : Error;
    var _message;
    if (typeof arg2 === 'string') _message = arg2;else if (typeof arg1 === 'string') _message = arg1;
    throw new Constructor(_message);
  }
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * 异步并发节流
 * @param tasks 异步任务列表
 * @param concurrency 并发数量
 */
function asyncThrottle(tasks) {
  var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Promise(function (resolve) {
    var entries = tasks.entries();
    var remains = tasks.length;
    var run = function run() {
      var _entries$next = entries.next(),
        value = _entries$next.value;
      if (!value) return;
      var _value = _slicedToArray(value, 2),
        task = _value[1];
      task()["finally"](function () {
        remains -= 1;
        return remains ? run() : resolve();
      });
    };
    Array.from({
      length: concurrency
    }).forEach(run);
  });
}

function buildFormData(obj) {
  var formData = new FormData();
  Object.entries(obj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value === null || value === undefined) return;
    if (value instanceof Blob) {
      formData.append(key, value);
    } else {
      formData.append(key, value.toString());
    }
  });
  return formData;
}

/**
 * 捕获并提取Promise错误对象
 * @param promise
 *
 * @example
 * const [error, user] = await catchError(apis.getUser())
 * if (error) return
 * console.log(user.name)
 */
function catchError(promise) {
  return Promise.resolve(promise).then(function (data) {
    return [undefined, data];
  })["catch"](function (error) {
    return [error || new Error(), undefined];
  });
}

/**
 * 本地时间转为utc对应时区的时间
 * @param date 本地时间日期对象
 * @param offsetMinutes 时区偏移分钟，0为零时区，480为东八区
 */
function dateUtcOffset(date) {
  var offsetMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var zeroTime = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
  return new Date(zeroTime + offsetMinutes * 60 * 1000);
}

/**
 * 简单的日期格式化
 * @param date 日期对象
 * @param format 格式化字符串
 */
function dateFormat(date, format, utcOffsetMinutes) {
  // token与moment保持一致：https://momentjs.com/docs/#/parsing/string-format/
  var map = {
    Y: date.getFullYear().toString(),
    Q: (Math.floor(date.getMonth() / 3) + 1).toString(),
    M: (date.getMonth() + 1).toString(),
    D: date.getDate().toString(),
    H: date.getHours().toString(),
    m: date.getMinutes().toString(),
    s: date.getSeconds().toString()
  };
  var tokens = Object.keys(map).map(function (c) {
    return "".concat(c, "+");
  }).join('|');
  if (utcOffsetMinutes !== undefined) {
    date = dateUtcOffset(date, utcOffsetMinutes);
  }
  var reg = new RegExp("(?<!\\\\)(".concat(tokens, ")"), 'g');
  return format.replace(reg, function (word) {
    return map[word[0]].padStart(word.length, '0');
  }).replace(/\\/g, '');
}

/**
 * 限制异步函数同时只能执行一次，期间多次调用都返回第一次的结果
 * @param fn 异步函数
 *
 * @example
 * const fn = limitOne(async (value) => {
 *   await delay(1000);
 *   return value;
 * });
 *
 * const result = await Promise.all([fn(1), fn(2), fn(3)]);
 *
 * console.log(result); // [1, 1, 1]
 */
function limitOne(fn) {
  var pending = null;
  return function () {
    if (pending) return pending;
    pending = Promise.resolve(fn.apply(void 0, arguments))["finally"](function () {
      pending = null;
    });
    return pending;
  };
}

/**
 * 延时
 * @param ms 时长（毫秒）
 *
 * @example
 * await delay(1000)
 */
function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

/**
 * 下载指定链接
 * @param url 链接地址
 * @param fileName 文件名
 */
function downloadUrl(url) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var link = document.createElement('a');
  link.setAttribute('style', 'display: none');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * 下载blob
 * @param blob 数据对象
 * @param fileName 文件名
 */
function downloadBlob(blob, fileName) {
  var url = URL.createObjectURL(blob);
  downloadUrl(url, fileName);
  URL.revokeObjectURL(url);
}

/**
 * 确保返回值为数组
 * @param value 值
 *
 * @example
 * ensureArray('a') // ['a']
 * ensureArray(['a']) // ['a']
 * ensureArray(null) // []
 * ensureArray(undefined) // []
 */
function ensureArray(value) {
  if (value === null || value === undefined) return [];
  return Array.isArray(value) ? value : [value];
}

/**
 * 缓存上次计算结果
 */
var caches = {
  horizontal: undefined,
  vertical: undefined
};

/**
 * horizontal 滚动条水平宽度
 * vertical 滚动条垂直宽度
 */

/**
 * 获取滚动条宽度
 * @param direction 方向
 */
function getScrollBarSize() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'horizontal';
  if (caches[direction] === undefined) {
    var div = document.createElement('div');
    var offsetProp = direction === 'horizontal' ? 'offsetWidth' : 'offsetHeight';
    var clientProp = direction === 'horizontal' ? 'clientWidth' : 'clientHeight';
    div.style.width = '100px';
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    document.body.appendChild(div);
    caches[direction] = div[offsetProp] - div[clientProp];
    document.body.removeChild(div);
  }
  return caches[direction];
}

/**
 * @see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html
 */

/**
 * 解析 JSON，失败时返回默认值
 * @param {string} json
 * @param {?T} fallback
 * @return {JSON|T|undefined}
 */
function jsonParse(json, fallback) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return fallback;
  }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * 空函数
 * @param _args 任意参数
 */
function noop() {
  /** 空 */
}

/**
 * 打开文件选择对话框
 * @param options 选项
 * @param callback 回调
 *
 * @example
 * const button = document.getElementById('button')
 *
 * button.addEventListener(async () => {
 *   const files = await openFileDialog()
 *   console.log(files, files.length)
 * })
 */
function openFileDialog(options, callback) {
  return new Promise(function (resolve) {
    var _ref = options || {},
      multiple = _ref.multiple,
      accept = _ref.accept,
      mimeTypes = _ref.mimeTypes;
    var filePicker = document.createElement('input');
    filePicker.style.position = 'fixed';
    filePicker.style.top = '0';
    filePicker.style.left = '0';
    filePicker.style.visibility = 'hidden';
    filePicker.setAttribute('type', 'file');
    if (multiple) {
      filePicker.setAttribute('multiple', '');
    }
    if (accept) {
      filePicker.setAttribute('accept', accept);
    } else if (mimeTypes) {
      filePicker.setAttribute('accept', mimeTypes.join(','));
    }
    var resolved = false;
    var resolveFiles = function resolveFiles() {
      var files = Array.from(filePicker.files || []);
      if (resolved) return;
      if (callback) callback(files);
      resolve(files);
      resolved = true;
    };
    var delayResolveFiles = function delayResolveFiles() {
      window.removeEventListener('focus', delayResolveFiles);
      setTimeout(resolveFiles, 500);
    };
    filePicker.addEventListener('change', resolveFiles);
    window.addEventListener('focus', delayResolveFiles);
    document.body.appendChild(filePicker);
    filePicker.click();
    document.body.removeChild(filePicker);
  });
}

/**
 * 函数promise化（确保原函数最后一个参数接收callback）
 * @param func 原函数
 */
function promisify(func) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      func.apply(void 0, args.concat([function (error, result) {
        return error ? reject(error) : resolve(result);
      }]));
    });
  };
}

/**
 * 读取文件作为文本
 * @param blob 数据对象
 * @param encoding 编码
 */
function readFileAsText(blob) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UTF-8';
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      return resolve(reader.result);
    };
    reader.onerror = function () {
      return reject(new Error());
    };
    reader.readAsText(blob, encoding);
  });
}

function resolve(source, mapper, key) {
  var transform = mapper[key];
  if (typeof transform === 'function') return transform(source);
  if (typeof transform === 'string') return source[transform];
  if (transform === true) return source[key];
  return undefined;
}
function recastObject(source, mapper, keepRest) {
  var dest = keepRest ? _objectSpread2({}, source) : {};
  Object.keys(mapper).forEach(function (key) {
    dest[key] = resolve(source, mapper, key);
  });
  return dest;
}
function isArray(arg) {
  return Array.isArray(arg);
}

/**
 * 将源对象或者列表重组为新对象或列表
 * @param source 源对象或列表
 * @param mapper 映射规则
 * @param keepRest 是否保持剩余属性
 *
 * @example
 * recast({ a: 1, b: 2 }, { c: 'a', d: 'b' }) // { c: 1, d: 2 }
 * recast({ a: 1, b: 2 }, { c: 'a', d: 'b' }, true) // { a: 1, b: 2, c: 1, d: 2 }
 * recast({ a: 1 }, { b: (src) => src.a + 1 }) // { b: 2 }
 * recast({ a: 1 }, { b: (src) => src.a + 1 }, true); // { a: 1, b: 2 }
 *
 * recast([{ a: 1, b: 2 }], { c: 'a', d: 'b' }) // [{ c: 1, d: 2 }]
 * recast([{ a: 1, b: 2 }], { c: 'a', d: 'b' }, true) // [{ a: 1, b: 2, c: 1, d: 2 }]
 * recast([{ a: 1 }], { b: (src) => src.a + 1 }) // [{ b: 2 }]
 * recast([{ a: 1 }], { b: (src) => src.a + 1 }, true); // [{ a: 1, b: 2 }]
 */

function recast(source, mapper, keepRest) {
  if (!source) return source;
  return isArray(source) ? source.map(function (item) {
    return recastObject(item, mapper, keepRest);
  }) : recastObject(source, mapper, keepRest);
}

var IntervalTimerStatus;
(function (IntervalTimerStatus) {
  IntervalTimerStatus[IntervalTimerStatus["Running"] = 1] = "Running";
  IntervalTimerStatus[IntervalTimerStatus["Paused"] = 2] = "Paused";
  IntervalTimerStatus[IntervalTimerStatus["Stopped"] = 3] = "Stopped";
})(IntervalTimerStatus || (IntervalTimerStatus = {}));
var defaultOptions = {
  ms: 0,
  immediate: false,
  pauseOnError: true,
  pauseOnInactive: true
};

/**
 * 设置间歇执行任务
 * @param callback 回调函数，支持返回Promise
 * @param ms 毫秒或参数对象
 */
function setIntervalTask(callback) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timer = {};
  var options = typeof ms === 'number' ? _objectSpread2(_objectSpread2({}, defaultOptions), {}, {
    ms: ms
  }) : _objectSpread2(_objectSpread2({}, defaultOptions), ms);

  /** 停止计时器 */
  var stop = function stop(status) {
    if (timer.id) {
      clearTimeout(timer.id);
      timer.id = undefined;
      timer.status = status;
    }
  };

  /** 执行下次回调函数 */
  var next = function next() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    timer.id = window.setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return callback();
          case 3:
            _context.next = 10;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            if (!options.pauseOnError) {
              _context.next = 10;
              break;
            }
            stop(IntervalTimerStatus.Paused);
            throw _context.t0;
          case 10:
            next();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    })), immediate ? 0 : options.ms);
  };

  /** 监听visibilitychange，判断网页是否处于活跃状态 */
  if (options.pauseOnInactive) {
    window.document.addEventListener('visibilitychange', function () {
      if (window.document.visibilityState === 'visible') {
        if (timer.status === IntervalTimerStatus.Paused) next(options.immediate);
      } else {
        stop(IntervalTimerStatus.Paused);
      }
    });
  }
  next(options.immediate);
  timer.status = IntervalTimerStatus.Running;
  timer.stop = function () {
    return stop(IntervalTimerStatus.Stopped);
  };
  return timer;
}

var attrs = {
  x: {
    position: 'scrollLeft',
    total: 'scrollWidth',
    offset: 'offsetWidth'
  },
  y: {
    position: 'scrollTop',
    total: 'scrollHeight',
    offset: 'offsetHeight'
  }
};
var isHtmlElement = function isHtmlElement(target) {
  return !!(target && _typeof(target) === 'object' && 'nodeName' in target && 'nodeType' in target && target.nodeType === 1);
};

/** 获取可滚动的距离 */
var getTotal = function getTotal(el, direction) {
  return el[attrs[direction].total] - el[attrs[direction].offset];
};

/** 获取当前滚动的位置 */
var getPosition = function getPosition(el, direction) {
  return el[attrs[direction].position];
};

/** 设置当前滚动的位置 */
var setPosition = function setPosition(el, direction, value) {
  el[attrs[direction].position] = value;
};

/**
 * 同步容器滚动条位置
 * @param elements 容器元素列表
 * @param direction 方向
 * @returns 取消同步函数
 */
function syncScrollBar(elements, direction) {
  var currentScrollEl;
  elements = elements.filter(isHtmlElement);
  var onScroll = function onScroll(e) {
    window.requestAnimationFrame(function () {
      if (!e.target) return;
      var position = getPosition(e.target, direction);
      var total = getTotal(e.target, direction);
      var percent = position / total;
      elements.forEach(function (dest) {
        if (dest === currentScrollEl) return;
        var destTotal = getTotal(dest, direction);
        var destPosition = destTotal * percent;
        setPosition(dest, direction, Math.round(destPosition));
      });
    });
  };
  var onMouseenter = function onMouseenter(e) {
    currentScrollEl = e.target;
  };
  elements.forEach(function (el) {
    el.addEventListener('scroll', onScroll);
    el.addEventListener('mouseenter', onMouseenter);
  });
  return function () {
    return elements.forEach(function (el) {
      el.removeEventListener('scroll', onScroll);
      el.removeEventListener('mouseenter', onMouseenter);
    });
  };
}

var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * 将字节数转化为可读性强的单位
 * @param bytes 字节数
 */
function toByteText(bytes) {
  var index = 0;
  var value = bytes;
  for (var i = 1; i < units.length; i += 1) {
    var v = value / 1024;
    if (v < 1) {
      break;
    }
    value = v;
    index = i;
  }
  return Number(value).toPrecision(4) + units[index];
}

/**
 * 遍历树形结构
 * @param tree 树形结构数据
 * @param childrenProp children属性名
 * @param callback 回调函数
 */
function treeWalk(tree, childrenProp, callback, parent) {
  ensureArray(tree).forEach(function (item) {
    callback(item, parent);
    if (Array.isArray(item[childrenProp])) {
      treeWalk(item[childrenProp], childrenProp, callback, item);
    }
  });
}

/**
 * 树形结构转为映射对象
 * @param tree 树形结构数据
 * @param keyProp key属性名
 * @param childrenProp children属性名
 * @returns 映射对象
 */
function tree2Object(tree, keyProp) {
  var childrenProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var record = {};
  treeWalk(tree, childrenProp, function (item) {
    var key = item[keyProp];
    if (key) record[key] = item;
  });
  return record;
}

/**
 * 树形结构查找节点
 * @param tree 树形结构数据
 * @param childrenProp children属性名
 * @param condition 条件函数
 */
function treeFind(tree, childrenProp, condition) {
  var list = ensureArray(tree);
  for (var i = 0; i < list.length; i += 1) {
    var _node = list[i];
    if (condition(_node)) return _node;
    var childNode = treeFind(_node[childrenProp] || [], childrenProp, condition);
    if (childNode) return childNode;
  }
  return undefined;
}

var AsyncTaskQueue = /*#__PURE__*/function () {
  function AsyncTaskQueue(concurrent) {
    _classCallCheck(this, AsyncTaskQueue);
    this.concurrent = concurrent;
    this.queue = [];
    this.runningCount = 0;
  }
  _createClass(AsyncTaskQueue, [{
    key: "add",
    value: function add(task) {
      this.queue.push(task);
      this.run();
    }
  }, {
    key: "run",
    value: function run() {
      var _this = this;
      if (this.queue.length === 0) return;
      if (this.runningCount >= this.concurrent) return;
      var task = this.queue.shift();
      if (task) {
        this.runningCount += 1;
        task()["finally"](function () {
          _this.runningCount -= 1;
          _this.run();
        });
      }
    }
  }]);
  return AsyncTaskQueue;
}();

function loadScript(url) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.onload = function () {
      return resolve();
    };
    script.onerror = function () {
      return reject();
    };
    document.head.appendChild(script);
  });
}

export { AsyncTaskQueue, array2Object, assert, asyncThrottle, buildFormData, catchError, dateFormat, dateUtcOffset, delay, downloadBlob, downloadUrl, ensureArray, getScrollBarSize, jsonParse, limitOne, loadScript, noop, openFileDialog, promisify, readFileAsText, recast, setIntervalTask, syncScrollBar, toByteText, tree2Object, treeFind, treeWalk };
